
import { Component, Vue, Watch } from 'vue-property-decorator'
import Multiselect from 'vue-multiselect'

import {
  getResolve,
  updateDoctor,
  postDoctor,
  getProgramOrServices,
  deleteDoctorAddress,
  getDoctors
} from '@/components/doctors/doctors.service'
import {
  PaginationVM,
  SelectVM,
  UserVM,
  RMTCreatedUser,
  Insurance,
  Role,
  SignUpBillingPrograms,
  SignUpRecordPrograms,
  SignUpServices,
  Address
} from '@/models'
import moment from 'moment'
import {
  deleteUser,
  getUsers,
  resendPassword,
  _change2FA,
  _toggleMaintenance,
  getMaintenanceStatus,
  _toggleLock,
  getUserRole,
  _validatePassword,
  getDoctorProfile,
  getSignUpResolve,
  resendProfileConfirmation,
  getCurrentUser,
  getUserRmtId
} from '@/components/admin/users/users.service'
import {
  getInsurances,
  getIPANumbers
} from '@/components/insurances/insurance.service'
import DoctorForm from './DoctorForm.vue'
import InsuranceForm from './InsuranceForm.vue'
import InsuranceSupervisorForm from './InsuranceSupervisorForm.vue'

type Tri = 'any' | 'true' | 'false'

@Component({
  components: {
    Multiselect,
    DoctorForm,
    InsuranceForm,
    InsuranceSupervisorForm
  }
})
export default class UsersView extends Vue {
  public expandAllRows = false
  public formExpanded = false
  public showInsurances = false
  public showInsurancesMulti = false
  public confirmation = ''
  public billingSoftware: SignUpBillingPrograms[] = []
  public selectedSoftware: SignUpBillingPrograms[] = []
  public electronicRecord: SignUpRecordPrograms[] = []
  public otherServices: SignUpServices[] = []
  public selectedRecord: SignUpRecordPrograms[] = []
  public selectedServices: SignUpServices[] = []
  public limitReached = false
  public fields = [
    {
      key: 'expand',
      label: ''
    },
    {
      key: 'index',
      label: '#'
    },
    // {
    //   key: 'userId',
    //   label: 'User ID'
    // },
    {
      key: 'documentID',
      label: 'Document ID',
      sortable: true
    },
    {
      key: 'speciality',
      label: 'Speciality',
      sortable: true
    },
    {
      key: 'fullName',
      label: 'User',
      sortable: true
    },
    {
      key: 'sex',
      label: 'Sex',
      sortable: true
    },
    // {
    //   key: 'dob',
    //   label: 'DOB',
    //   formatter: 'formatDate',
    //   sortable: true
    // },
    // {
    //   key: 'phone',
    //   label: 'Phone 1',
    //   sortable: true
    // },
    // {
    //   key: 'mobile',
    //   label: 'Phone 2'
    // },
    {
      key: 'email1',
      label: 'Email',
      sortable: true
    },

    {
      key: 'rolName',
      label: 'Role',
      sortable: true
    },
    {
      key: 'creationDate',
      label: 'Created At',
      sortable: true
    },

    {
      key: 'active',
      label: 'Active',
      sortable: true
    },
    {
      key: 'isLocked',
      label: 'Locked',
      sortable: true
    },
    {
      key: 'twoFactorEnabled',
      label: '2FA',
      sortable: false
    },
    {
      key: 'policyAcceptanceFlag',
      label: 'Policy',
      sortable: true
    },
    {
      key: 'show_details',
      label: ''
    }
  ]
  public items: RMTCreatedUser[] = []
  public documentLabel = 'NPI'
  public insurances: Insurance[] = []
  public insurancesPlans: SelectVM[] = []
  public selectedDoctor: SelectVM | null = null
  public doctorList: SelectVM[] = []
  public genders: SelectVM[] = []
  public roles: SelectVM[] = []
  public selectedDoctorLimit = null
  public selectedDoctorQty = null

  public statusList = [
    {
      label: 'Active',
      value: true
    },
    {
      label: 'Inactive',
      value: false
    }
  ]
  public policyList = [
    {
      label: 'Accepted',
      value: true
    },
    {
      label: 'Not Accepted',
      value: false
    }
    // {
    //   label: 'N/A',
    //   value: null
    // }
  ]
  public twoFactorList = [
    {
      label: 'Set',
      value: true
    },
    {
      label: 'Not Set',
      value: false
    }
  ]

  public selectedStatusFilter = null
  public selectedTwoFactorFilter = null
  public selectedPolicyFilter = null

  public selectedGender: string | null = null
  public selectedRole: string | null = null
  public selectedRoleFilter: string | null = null
  public isAdmin = false
  public isInsuranceSupervisor = false
  public isUnderMaintenance = false
  public form = {
    insurances: null,
    insuranceIPA: null,
    doctorAddresses: null,
    rmtBillingProgram: null,
    rmtServices: null,
    rmtRecordProgram: null,
    sex: null,
    _showInsuranceAgreementAlert: false
  } as UserVM
  public isEditing = false
  public perPage = 10
  public pageOptions = [10, 20, 50, 100, 250, 500, 1000]
  public pagination = {} as PaginationVM
  public searchQuery = ''
  public currentRole = ''
  public formatted = ''
  public selectedInsurance: string | number | null = ''
  public selectedInsurances: string[] = []
  public ipaNumberOptions: { value: number; text: string }[] = []
  public ipaLoadSeq = 0

  public showOtherBilling = false
  public showOtherProgram = false
  public showExtraFields = false
  public currentUser = null
  public isDoctor = false
  public userInsurances = null
  @Watch('perPage')
  perPageChange() {
    this.getUsers()
  }
  get hasSelectedInsurance() {
    return (
      this.selectedInsurance !== null &&
      this.selectedInsurance !== undefined &&
      String(this.selectedInsurance).trim() !== ''
    )
  }

  get ipaSelectPlaceholder() {
    if (!this.hasSelectedInsurance) {
      return 'Select an insurance first'
    }
    if (!this.ipaNumberOptions.length) {
      return 'No IPA numbers for this insurance'
    }
    return 'Select IPA number'
  }

  @Watch('selectedInsurance')
  async onSelectedInsuranceChange(
    val: string | number | null,
    oldVal: string | number | null
  ) {
    if (
      this.form.role !== Role.InsuranceStaff &&
      this.form.rolName !== Role.InsuranceStaff
    ) {
      return
    }
    const hasId = val !== null && val !== undefined && String(val).trim() !== ''
    this.form.insuranceID = hasId ? Number(val) : null
    this.form.insurances = hasId ? String(val).trim() : null
    const insuranceChanged =
      String(oldVal ?? '').trim() !== '' &&
      String(oldVal ?? '') !== String(val ?? '')
    if (insuranceChanged) {
      this.form.ipaNumber = null
    }
    await this.loadIpaOptionsForInsurance(val)
  }

  public async loadIpaOptionsForInsurance(insuranceId: string | number | null) {
    const token = ++this.ipaLoadSeq
    const hasId =
      insuranceId !== null &&
      insuranceId !== undefined &&
      String(insuranceId).trim() !== ''
    if (!hasId) {
      this.ipaNumberOptions = []
      return
    }
    try {
      const response = await getIPANumbers(String(insuranceId).trim())
      if (token !== this.ipaLoadSeq) return
      const seen = new Set<number>()
      const options: { value: number; text: string }[] = []
      for (const row of response?.data || []) {
        const n = Number(row.ipaNumber)
        if (Number.isNaN(n) || seen.has(n)) continue
        seen.add(n)
        options.push({
          value: n,
          text: row.insuranceIPA || String(row.ipaNumber)
        })
      }
      options.sort((a, b) => a.text.localeCompare(b.text))
      const current = Number(this.form.ipaNumber)
      if (
        !Number.isNaN(current) &&
        this.form.ipaNumber !== null &&
        this.form.ipaNumber !== undefined &&
        String(this.form.ipaNumber).trim() !== '' &&
        !seen.has(current)
      ) {
        options.unshift({
          value: current,
          text: String(this.form.ipaNumber)
        })
      }
      this.ipaNumberOptions = options
      if (!Number.isNaN(current) && seen.has(current)) {
        this.form.ipaNumber = current
      }
    } catch (err) {
      if (token !== this.ipaLoadSeq) return
      this.ipaNumberOptions = []
      console.error(err)
    }
  }
  public async onPageChange(pageNumber: number) {
    this.expandAllRows = false
    await this.getUsers(pageNumber)
  }
  public addressGroups: Address[] = [
    {
      addressID: null,
      city: null,
      confirmation: null,
      email: null,
      email1: null,
      location_name: null,
      phone: null,
      phone1: null,
      phone2: null,
      selected: null,
      state: null,
      street: null,
      zip: null,
      mobile: null
    }
  ]
  public removeAddressGroup(address, index: number) {
    this.$swal
      .fire({
        title: 'Are you sure?',
        text: `This will delete this address permanently`,
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirm'
      })
      .then(result => {
        if (result.isConfirmed) {
          if (address.addressID) {
            const obj = {
              doctorID: address.doctorID,
              addressID: address.addressID
            }
            deleteDoctorAddress(obj)
          }
          // resendProfileConfirmation(rmT_UserId)
          this.addressGroups.splice(index, 1)
        }
      })
  }
  public addMore() {
    const obj = {} as Address

    this.addressGroups.push(obj)
  }
  get _pagination() {
    return this.pagination
  }

  public getLength(value) {
    return value ? value.toString().trim().length : 0
  }

  public async onSelectedDoctor(value) {
    const response = await getDoctorProfile(value.documentId)
    this.selectedDoctorLimit = response.doctorstaffNolimit
    this.selectedDoctorQty = response.doctorstaffQty || 0

    if (this.selectedDoctorQty == this.selectedDoctorLimit && !this.isEditing) {
      this.$bvToast.toast(
        `The Doctor ${this.selectedDoctor.label} has reached the Doctor Staff Limit`,
        {
          title: 'Limit Reached!',
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 5000,
          appendToast: true
        }
      )
      // this.limitReached = true
      this.selectedDoctor = null
    } else {
      // this.limitReached = false
    }
  }

  //   filters = {
  //   pageNumber: 1,
  //   pageSize: 25,
  //   searchQuery: '',
  //   searchFields: 'FullName,DocumentID,Email1',
  //   roleIds: [] as number[],
  //   activeIn: [] as boolean[],  // e.g. [true] or [false] or [true,false]
  //   twoFAIn:  [] as boolean[],
  // };

  // private setFilters(partial: Partial<typeof this.filters>) {
  //   this.filters = { ...this.filters, ...partial, pageNumber: 1 };
  //   this.getUsers(); // always queries with the full, updated filter state
  // }

  // public async getUsers(pageNumber?: number) {
  //   if (pageNumber) this.filters.pageNumber = pageNumber;

  //   const resp = await getUsers(this.filters); // axios helper from earlier
  //   this.items = resp.data;
  //   this.pagination = JSON.parse(resp.headers['x-pagination']);
  // }

  private tri(v: Tri): boolean | null {
    if (v === 'true') return true
    if (v === 'false') return false
    return null
  }

  public async filter() {
    await this.getUsers(1)
  }

  public async resetFilters() {
    this.searchQuery = ''
    this.selectedRoleFilter = null
    this.selectedStatusFilter = null
    this.selectedPolicyFilter = null

    this.selectedTwoFactorFilter = null
    await this.getUsers(1)
  }

  public async getUsers(pageNumber = 1) {
    const doctorHeadID =
      getUserRole() == Role.DoctorStaff ? +getUserRmtId() : null

    const resp = await getUsers({
      pageNumber,
      pageSize: this.perPage,
      searchQuery: this.searchQuery,
      roleId: this.selectedRoleFilter?.value,
      active: this.selectedStatusFilter?.value, //this.tri(this.selectedStatusFilter?.value || true),
      twoFA: this.selectedTwoFactorFilter?.value, //this.tri(this.selectedTwoFactorFilter?.value || true),
      policyAcceptance: this.selectedPolicyFilter?.value,
      doctorHeadID
    })
    this.items = resp.data
    this.pagination = JSON.parse(resp.headers['x-pagination'])
  }
  public onBillingSoftwareInput(e) {
    this.form.rmtBillingProgram = e.join(',')
    const id = this.billingSoftware.filter(
      c => c.billingProgramName == 'Other'
    )[0].billingProgramID

    this.showOtherBilling = e.includes(id)
  }
  public onRecordSoftwareInput(e) {
    this.form.rmtRecordProgram = e.join(',')
    const id = this.electronicRecord.filter(
      c => c.recordProgramName == 'Other'
    )[0].recordProgramID

    this.showOtherProgram = e.includes(id)
  }
  public onOtherServicesInput(e) {
    this.form.rmtServices = e.join(',')
  }

  public async mounted() {
    const result = await getSignUpResolve()
    const response = await getResolve(this.isDoctor)
    const doctors = await getDoctors(1, 9999)

    this.genders = response.genders
    this.roles = response.roles

    if (this.isDoctor) {
      this.selectedRole = this.roles.find(
        c => c.label == Role.DoctorStaff
      ).value
    }

    if (getUserRole() == Role.Doctor) {
      this.doctorList = doctors.data
        .filter(c => c.doctorId == getCurrentUser().rmtUserId)
        .map(c => {
          return {
            label: c.documentId + ' - ' + c.fullName,
            value: c.doctorId.toString(),
            documentId: c.documentId
          }
        })
    } else {
      this.doctorList = doctors.data.map(c => {
        return {
          label: c.documentId + ' - ' + c.fullName,
          value: c.doctorId.toString(),
          documentId: c.documentId
        }
      })
    }

    // console.log(this.doctorList)
    // const genders = await getGenders()
    // this.genders = genders
    this.billingSoftware = result.billingPrograms
    this.electronicRecord = result.recordPrograms
    this.otherServices = result.services
    // console.log(response)
    // this.complete == true
    //   ? (this.formType = 'Complete Profile')
    //   : (this.formType = 'Registration Form')

    // if (localStorage.getItem('currentUser') && this.complete) {
    //   const u = localStorage.getItem('currentUser')
    //   const currentUser = JSON.parse(u || '{}')
    //   item = await getDoctorProfile(currentUser.userName)
    //   this.selectedGender = this.genders.find(c => c.label == 'M').value
    //   console.log(item)
    //   this.formatted = this.formatDate(item.dob.toString())
    // }
  }
  private async created() {
    this.currentRole = getUserRole()
    if (this.currentRole == Role.Admin) {
      this.isAdmin = true
      try {
        this.isUnderMaintenance = await getMaintenanceStatus()
      } catch {
        this.isUnderMaintenance = false
      }
    } else if (this.currentRole == Role.InsuranceSupervisor) {
      this.isInsuranceSupervisor = true
    } else if (this.currentRole == Role.Doctor) {
      this.isAdmin = false
      this.isDoctor = true
    }
    // console.log(this.currentRole)
    await this.getUsers()
  }
  public async getUsersByRole() {
    // this.getUsers(1, event.label)
  }
  public onContext(ctx) {
    this.formatted = moment(ctx).format('MM/DD/YYYY')
  }
  public onInput(ctx) {
    const a = moment(ctx).toDate()
    if (a.toString() != 'Invalid Date') this.form.dob = a
  }

  @Watch('selectedRole')
  async onSelectedRoleChange(value: string) {
    // this.form = {
    //   insurances: null,
    //   doctorAddresses: null,
    //   rmtBillingProgram: null,
    //   rmtServices: null,
    //   rmtRecordProgram: null,
    //   sex: null
    // } as UserVM
    const a = this.roles.find(z => z.value == value)?.label
    this.showInsurances = false
    this.showInsurancesMulti = false
    if (a === Role.Doctor || a === Role.DoctorStaff) {
      this.documentLabel = 'NPI'

      this.showExtraFields = true
      if (a === Role.DoctorStaff) {
        this.form.role = Role.DoctorStaff
      } else {
        this.form.role = Role.Doctor
        this.showExtraFields = false
      }
    } else if (
      a === Role.Staff ||
      a === Role.Training ||
      a === Role.Insurance
    ) {
      this.documentLabel = 'DocumentID'
      this.form.role = a
      this.showExtraFields = false
    } else if (a === Role.InsuranceSupervisor) {
      this.documentLabel = 'DocumentID'
      this.form.role = Role.InsuranceSupervisor
      this.showExtraFields = false
    } else if (a === Role.InsuranceStaff) {
      this.documentLabel = 'DocumentID'
      this.form.role = Role.InsuranceStaff
      const response = await getInsurances(1, 1500)
      this.insurances = response.data
      this.showExtraFields = false
      this.showInsurances = true
      if (this.selectedInsurance !== '' && this.selectedInsurance != null) {
        const n = Number(this.selectedInsurance)
        if (!Number.isNaN(n)) this.selectedInsurance = n
      }
      await this.loadIpaOptionsForInsurance(this.selectedInsurance)
    } else if (a === Role.Insurance) {
      this.showInsurancesMulti = true
    }
  }

  public async cleanFilter() {
    this.searchQuery = ''
    await this.getUsers()
  }
  public async toggleForm() {
    this.formExpanded = !this.formExpanded
    if (!this.formExpanded) {
      this.selectedRole = null
      this.form = {
        insurances: null,
        insuranceIPA: null,
        doctorAddresses: null,
        rmtBillingProgram: null,
        rmtServices: null,
        rmtRecordProgram: null,
        sex: null,
        _showInsuranceAgreementAlert: false
      } as UserVM
      // this.addressGroups = []
      this.selectedGender = null
      this.formatted = null
      this.isEditing = false
      this.confirmation = ''
      this.selectedDoctorLimit = null
      this.selectedDoctorQty = null
      this.selectedDoctor = null
      this.ipaNumberOptions = []
      this.ipaLoadSeq += 1
    } else {
      await this.fillFields()
    }
  }
  public toggleUnderMaintenance() {
    const turningOn = !this.isUnderMaintenance
    this.$swal
      .fire({
        title: 'Are you sure?',
        text: turningOn
          ? 'This will set the website as UNDER MAINTENANCE'
          : 'This will take the website OUT of maintenance',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirm'
      })
      .then((result): void => {
        if (result.isConfirmed) {
          this.$swal
            .fire({
              title: 'Please confirm your password',
              html: `
  <input type="password" autocomplete="new-password" id="password" class="swal2-input" placeholder="Password">`,
              confirmButtonText: 'Confirm',
              focusConfirm: false,
              preConfirm: () => {
                const password = this.$swal
                  .getPopup()
                  .querySelector('#password').value
                if (!password) {
                  this.$swal.showValidationMessage(`Please enter your password`)
                }
                return { password: password }
              }
            })
            .then(result => {
              _validatePassword(result.value.password).then(c => {
                if (c === true) {
                  _toggleMaintenance(turningOn).then(async () => {
                    this.isUnderMaintenance = await getMaintenanceStatus()
                    this.$swal.fire({
                      text: this.isUnderMaintenance
                        ? 'This website now is UNDER MAINTENANCE'
                        : 'Maintenance is now disabled',
                      icon: 'success'
                    })
                  })
                } else {
                  this.$swal.fire({
                    text: 'Wrong password',
                    icon: 'warning'
                  })
                }
              })
            })
        }
      })
  }
  public toggleRow() {
    this.items = this.items.map(c => {
      return { ...c, _showDetails: !c._showDetails }
    })
    this.expandAllRows = !this.expandAllRows
  }

  // private async _getDoctors(pageNumber = 1, searchQuery = '') {
  //   const response = await getDoctors(pageNumber, this.perPage, searchQuery)
  //   this.items = response.data
  //   this.pagination = JSON.parse(response.headers['x-pagination'])
  // }
  public formatDate(value: string) {
    if (value) return moment(value).format('MM/DD/YYYY')
  }
  public formatBoolean(value: boolean | null): 'Yes' | 'No' | 'N/A' {
    if (value === null) return 'N/A'
    return value ? 'Yes' : 'No'
  }

  public getAge(value: string) {
    if (value) return moment().diff(value, 'years')
  }
  public async fillFields() {
    if (!this.formExpanded) return
    const response = await getResolve(this.isDoctor)
    if (!response) return

    this.genders = response.genders
    this.roles = response.roles
    if (this.selectedRole == 'Doctor') {
      this.form.doctorstaffNolimit = 5
    }
  }
  public async edit(item: UserVM) {
    this.formExpanded = true
    this.isEditing = true
    this.form.documentID = '1231131'

    // if (item.rolName == Role.Doctor) {
    //   this.userInsurances = this.form.insurances
    // }

    if (item.doctorstaffNolimit == null && this.selectedRole == 'Doctor') {
      item.doctorstaffNolimit = 5
    }

    if (item.doctorAddresses.length > 0) {
      this.addressGroups = item.doctorAddresses
      // this.addressGroups.map(c => {
      //   ;(c.confirmation = c.email), (c.phone1 = c.phone1?.trim())
      //   c.phone2 = c.phone2?.trim()
      //   c.phone = c.phone?.trim()
      // })
      this.addressGroups.map(c => {
        ;(c.confirmation = c.email), (c.phone1 = c.phone1?.trim())
        const userMobile = item.mobile?.trim()
        if (userMobile) {
          c.phone2 = userMobile
          c.mobile = userMobile
        } else {
          // fallback if user mobile is empty
          c.phone2 = (c.phone2 || c.mobile)?.trim()
          c.mobile = c.phone2
        }

        c.phone = c.phone?.trim()
        // c.phone2 = (c.phone2 || c.mobile)?.trim()
        // c.mobile = c.phone2
        // c.phone = c.phone?.trim()
      })
    } else {
      this.addressGroups[0].city = item.city
      this.addressGroups[0].phone1 = item.phone
      this.addressGroups[0].phone2 = item.mobile?.trim()
      this.addressGroups[0].mobile = item.mobile?.trim()

      this.addressGroups[0].email = item.email1
      this.addressGroups[0].confirmation = item.email1
      this.addressGroups[0].zip = item.zip
      this.addressGroups[0].street = item.street
      this.addressGroups[0].state = item.state
    }

    const rmtUserId = this.rmtUserIdFrom(item)
    this.form = {
      ...item,
      phone: item.phone?.trim(),
      mobile: item.mobile?.trim(),
      role: item.rolName || item.role,
      ...(rmtUserId ? { rmT_UserId: rmtUserId } : {})
    }
    this.selectedDoctor = this.doctorList.filter(c => {
      if (c.value == item.doctorHeadID) {
        return {
          label: c.label,
          value: item.doctorHeadID,
          documentId: item.documentID
        }
      }
    })

    this.selectedInsurance =
      item.insuranceID != null && item.insuranceID !== undefined
        ? item.insuranceID
        : ''
    this.confirmation = item.email1

    this.selectedGender = this.genders.find(
      z => z.label === this.form.sex
    )?.value
    this.selectedRole = item.roleId

    // console.log(item.)

    // console.log(Role.Doctor)
    if (this.selectedRole == 5 || this.selectedRole == 11) {
      // console.log(item.doctorAddresses)
      // console.log(item)
      // item.addresses = item.doctorAddresses
      const data = await getProgramOrServices(this.form.documentID)

      const groupedData = data.reduce((acc, curr) => {
        if (!acc[curr.porS_Identifier]) {
          acc[curr.porS_Identifier] = []
        }
        acc[curr.porS_Identifier].push(curr.porS_Id)
        return acc
      }, {})

      const result = Object.keys(groupedData).map(key => ({
        text: key,
        value: groupedData[key]
      }))

      this.selectedRecord = result.filter(
        c => c.text == 'Record_Program'
      )[0].value
      this.selectedServices = result.filter(
        c => c.text == 'Service_Required'
      )[0].value

      this.selectedSoftware = result.filter(
        c => c.text == 'Billing_Program'
      )[0].value

      // console.log(result)
      // console.log(data)
      this.form.otherBillingProgram = data.filter(
        c =>
          c.porS_Identifier == 'Billing_Program' &&
          c.programorServiceName2 == 'Other'
      )[0]?.programorServiceName
      this.form.otherRecordProgram = data.filter(
        c =>
          c.porS_Identifier == 'Record_Program' &&
          c.programorServiceName2 == 'Other'
      )[0]?.programorServiceName
      // console.log(this.form.otherBillingProgram)
      // console.log(this.selectedRecord)
      // billingProgramID: number
      // billingProgramName: string
      // recordProgramID: number
      // recordProgramName: string
      // this.selectedRecord = result.map(c => {
      //   c.value
      // })

      // data.filter(c=> c.programOrServiceName2)
    }

    this.formatted = this.formatDate(this.form.dob?.toString())
  }

  public resendProfileConfirmation(rmT_UserId: number) {
    this.$swal
      .fire({
        title: 'Are you sure?',
        text: `This will reset the user profile confirmation`,
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirm'
      })
      .then(result => {
        if (result.isConfirmed) {
          resendProfileConfirmation(rmT_UserId)
        }
      })
  }

  public async resendPassword(item: UserVM) {
    this.$swal
      .fire({
        title: 'Are you sure?',
        text: `This will reset the user password and send it to his/her inbox`,
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirm'
      })
      .then(result => {
        if (result.isConfirmed) {
          resendPassword(item)
        }
      })
  }
  private rmtUserIdFrom(obj?: object): number {
    if (!obj) return 0
    const rec = obj as Record<string, unknown>
    for (const key of ['rmT_UserId', 'rMT_UserId', 'rmtUserId', 'RMT_UserId']) {
      const n = Number(rec[key])
      if (!Number.isNaN(n) && n > 0) return n
    }
    return 0
  }
  private csvFromSelect(list?: SelectVM[]): string {
    return [
      ...new Set(
        (list || []).map(i => String(i.value ?? '').trim()).filter(Boolean)
      )
    ].join(',')
  }
  private applyInsuranceSelectionFromChild(obj: UserVM) {
    if (obj.role === Role.Doctor) {
      const child = this.$refs.doctorForm as
        | { selectedInsurances?: SelectVM[] }
        | undefined
      if (child?.selectedInsurances) {
        obj.insurances = this.csvFromSelect(child.selectedInsurances)
      }
    } else if (obj.role === Role.Insurance) {
      const child = this.$refs.insuranceForm as
        | { selectedInsurances?: SelectVM[] }
        | undefined
      if (child?.selectedInsurances) {
        obj.insurances = this.csvFromSelect(child.selectedInsurances)
      }
    } else if (obj.role === Role.InsuranceSupervisor) {
      obj.role = Role.InsuranceSupervisor
      const child = this.$refs.insuranceSupervisorForm as
        | { selectedInsuranceIPAs?: SelectVM[] }
        | undefined
      if (child?.selectedInsuranceIPAs) {
        obj.insuranceIPA = (child.selectedInsuranceIPAs || [])
          .map(i => String(i.label || '').trim())
          .filter(Boolean)
          .join(',')
      }
      const rmtUserId = this.rmtUserIdFrom(obj) || this.rmtUserIdFrom(this.form)
      if (rmtUserId) {
        obj.rmT_UserId = rmtUserId
      }
    } else if (
      obj.role === Role.InsuranceStaff ||
      obj.rolName === Role.InsuranceStaff
    ) {
      obj.role = Role.InsuranceStaff
      const raw = this.selectedInsurance
      const hasId =
        raw !== null && raw !== undefined && String(raw).trim() !== ''
      obj.insurances = hasId ? String(raw).trim() : null
      obj.insuranceID = hasId ? Number(raw) : null
      const ipa = obj.ipaNumber ?? this.form.ipaNumber
      obj.ipaNumber =
        ipa === '' || ipa === undefined || ipa === null ? null : Number(ipa)
      const rmtUserId = this.rmtUserIdFrom(obj) || this.rmtUserIdFrom(this.form)
      if (rmtUserId) {
        obj.rmT_UserId = rmtUserId
      }
    }
  }
  public async create(): Promise<void> {
    const isValid = await this.$refs.observer.validate()
    if (!isValid) {
      return
    }

    let obj = {
      ...this.form,
      insuranceID: +this.selectedInsurance || null,
      role: this.form.role || this.form.rolName,
      doctorHeadID: this.selectedDoctor?.value
    } as UserVM
    this.applyInsuranceSelectionFromChild(obj)
    // InsuranceSupervisor → create uses @InsuranceMgrFlag+@InsuranceIPA;
    // edit updateDoctor calls sp_Update_RMT_InsuranceSupervisorAndRMT_Users
    if (obj.role === Role.InsuranceSupervisor) {
      obj.insurances = null
      obj.ipaNumber = null
      obj.insuranceID = null
    }
    if (
      this.selectedRole != '5' &&
      this.selectedRole != '12' &&
      obj.role !== Role.InsuranceSupervisor
    ) {
      obj.sex = this.genders.find(c => c.value == this.selectedGender)?.label
    }

    if (this.selectedRole == '11') {
      this.addressGroups.map(c => {
        ;(c.email1 = c.email), (c.phone = c.phone1)
        c.mobile = c.phone2 // ✅ Phone2 in UI becomes mobile in payload
      })

      obj = {
        ...obj,
        ...this.addressGroups[0],
        doctorAddresses: this.addressGroups
      }
      if (this.selectedRole == '11') {
        obj.role = 'DoctorStaff'
      }
    }
    if (this.selectedRole)
      if (!this.isEditing) {
        obj.role = this.form.role

        await postDoctor(obj)
      } else {
        if (obj.role == Role.Doctor) {
          obj.rmtRecordProgram = this.form.rmtRecordProgram
          obj.rmtBillingProgram = this.form.rmtBillingProgram
          obj.rmtServices = this.form.rmtServices
          const rmtUserId =
            this.rmtUserIdFrom(obj) || this.rmtUserIdFrom(this.form)
          if (rmtUserId) {
            obj.rmT_UserId = rmtUserId
          }
        } else if (obj.role == Role.DoctorStaff) {
          obj.rmtRecordProgram = this.selectedRecord.join(',')
          obj.rmtBillingProgram = this.selectedSoftware.join(',')
          obj.rmtServices = this.selectedServices.join(',')
        }

        if (this.form._showInsuranceAgreementAlert) {
          const result = await this.$swal.fire({
            title: 'WARNING',
            text:
              'Removing an insurance from a doctor will remove all the insurance agreements associated with that insurance. Are you sure you want to proceed?',
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'I Agree',
            showCancelButton: true,
            cancelButtonColor: '#d33',
            cancelButtonText: 'Cancel'
          })
          if (!result.isConfirmed) {
            return
          }
          this.form._showInsuranceAgreementAlert = false
        }
        this.applyInsuranceSelectionFromChild(obj)
        await updateDoctor(obj)
      }
    this.clearFields()
    await this.getUsers()
  }
  public clearFields() {
    this.isEditing = false
    this.formExpanded = false
    this.form = {} as UserVM
    this.selectedGender = null
    this.formatted = ''
    this.selectedRole = null
    this.selectedDoctor = null
    this.selectedInsurance = null
    this.ipaNumberOptions = []
    this.ipaLoadSeq += 1
    this.addressGroups = [
      {
        addressID: null,
        city: null,
        confirmation: null,
        email: null,
        email1: null,
        location_name: null,
        phone: null,
        phone1: null,
        phone2: null,
        selected: null,
        state: null,
        street: null,
        zip: null,
        mobile: null
      }
    ]
    this.selectedSoftware = null
    this.selectedRecord = null
    this.selectedServices = null
    this.confirmation = null
  }
  public change2FA(checked: boolean, item: RMTCreatedUser) {
    _change2FA({ checked, userId: item.userId })
  }
  public changeStatus(checked: boolean, item: RMTCreatedUser) {
    this.$swal
      .fire({
        title: 'Are you sure?',
        text: `This user status will be set as ${
          checked ? 'Active' : 'Inactive'
        }`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirm'
      })
      .then((result): void => {
        if (result.isConfirmed) {
          deleteUser(item.userId)
          this.$swal.fire(
            `${checked ? 'Activated' : 'Deactivated'}!`,
            `The user has been ${
              checked ? 'Activated' : 'Deactivated'
            } successfully`,
            'success'
          )
        } else {
          item.active = !item.active
        }
      })
  }
  public changeLock(checked: boolean, item: RMTCreatedUser) {
    this.$swal
      .fire({
        title: 'Are you sure?',
        text: `This user will be ${checked ? 'Locked' : 'Unlocked'}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirm'
      })
      .then((result): void => {
        if (result.isConfirmed) {
          _toggleLock(item.userId)
            .then(() => {
              this.$swal.fire({
                text: `The user is now ${checked ? 'Locked' : 'Unlocked'}`,
                icon: 'success'
              })
            })
            .catch(() => {
              item.isLocked = !item.isLocked
            })
        } else {
          item.isLocked = !item.isLocked
        }
      })
  }
}
